import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, Renderer2, AfterViewInit } from '@angular/core';
import { MapLocation } from '../../../../core/components/map-picker/map-picker.component';
import { PhotoDto } from '../../../../../models/trofaco/photoDto';
import { HttpClient } from '@angular/common/http';
declare var loadImage: any; 

@Component({
    selector: 'app-photo-editor',
    templateUrl: './photo-editor.component.html',
    styleUrls: ['./photo-editor.component.css']
})
export class PhotoEditorComponent implements OnInit, AfterViewInit {
    private _photo: PhotoDto;
    private oldCanvas: HTMLCanvasElement;

    @ViewChild('imageContainer', {static: false}) imageContainer: ElementRef<HTMLDivElement>;
    
    @Input()
    canSetThumbnail = false;

    @Input()
    defaultMapLocation: MapLocation;
    @Input()
    showValidation = false;

    @Output()
    setAsThumbnail = new EventEmitter<PhotoDto>();

    mapLocation: MapLocation;

    get photo(): PhotoDto {
        return this._photo;
    }

    @Input()
    set photo(value: PhotoDto) {
        this._photo = value;
        if (value.lat && value.lon) {
            this.mapLocation = {lng: value.lon, lat: value.lat};
        } else {
            setTimeout(() => this.mapLocation = this.defaultMapLocation);
        }

        if (this.oldCanvas) {
            this.renderer.removeChild(this.imageContainer, this.oldCanvas);
            this.renderPreviewPhoto();
        }
    }

    constructor(private renderer: Renderer2, private http: HttpClient) {
    }

    ngOnInit() {
    }

    ngAfterViewInit(){
        if(this.photo)
            this.renderPreviewPhoto();
    }

    setPhotoLocation(event: MapLocation) {
        this.photo.lat = event.lat;
        this.photo.lon = event.lng;
    }

    private renderPreviewPhoto(){
        let url = (<any>this.photo.originalUrl).changingThisBreaksApplicationSecurity;
        if (url) {
            this.http.get('' + url, {responseType: 'blob'}).subscribe((blob) => {
                this.renderPhotoFromFile(blob);
            });
        }else{
            let imgEle = new Image()
            imgEle.setAttribute('src', (<string>this.photo.originalUrl));
            this.renderer.appendChild(this.imageContainer.nativeElement, imgEle);
        }
    }

    private renderPhotoFromFile(file: Blob){
        let options = {
            maxWidth: this.imageContainer.nativeElement.parentElement.offsetWidth,
            pixelRatio: window.devicePixelRatio,
            downsamplingRatio: 0.5,
            orientation: true
        }
        
        loadImage(file, (canvas: HTMLCanvasElement) => {
            this.oldCanvas = canvas;
            this.renderer.appendChild(this.imageContainer.nativeElement, canvas);
        }, options);
    }

}
